import * as types from "./types";
import _ from "lodash";
export default (state = [], action) => {
  switch (action.type) {
    case types.FETCH_COMMISSION_MASTER_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    case types.CREATE_COMMISSION_MASTER:
      return { ...state, ..._.mapKeys(action.payload, "value") };
    case types.EDIT_COMMISSION_MASTER:
      return { ...state, ..._.mapKeys(action.payload, "value") };
    case types.DELETE_COMMISSION_MASTER:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
